


























































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ModalDadosBancarios extends Vue {
  @Prop({ required: true }) public showModal!: boolean;

  private toggleModal() {
    this.$emit("update:showModal", false);
  }
}
